import type { MatterType } from '@nestjs-boilerplate/types';

export interface MatterTypeOption {
  value: MatterType;
  label: string;
}

export const MATTER_TYPE_OPTIONS: MatterTypeOption[] = [
  { value: 'CONVEYANCING_RESIDENTIAL', label: 'Conveyancing (Residential)' },
  { value: 'CONVEYANCING_COMMERCIAL', label: 'Conveyancing (Commercial)' },
  { value: 'PROBATE_AND_WILLS', label: 'Probate and Wills' },
  { value: 'FAMILY_LAW', label: 'Family Law' },
  { value: 'LITIGATION', label: 'Litigation' },
  { value: 'CORPORATE_AND_COMMERCIAL', label: 'Corporate and Commercial' },
  { value: 'IMMIGRATION', label: 'Immigration' },
  { value: 'EMPLOYMENT', label: 'Employment' },
  { value: 'PERSONAL_INJURY', label: 'Personal Injury' },
  { value: 'CRIMINAL_DEFENCE', label: 'Criminal Defence' },
  { value: 'OTHER', label: 'Other' },
];
